/**
 * Created by Bart Decorte
 * Date: 29/10/2018
 * Time: 20:43
 */

class CsvMapModal {

  constructor() {
    this.cssSelector = '#modal-csv-map';
    this.$root = $(this.cssSelector);
    this.bindListeners();
  }

  bindListeners() {
    this.$root.on('change', '.js-csv-mapping-select', ev => this.csvMappingSelectChanged(ev));
    this.$root.on('change', '.js-headings', ev => this.headingsChanged(ev)).trigger('change');
  }

  csvMappingSelectChanged(ev) {
    let $elt = $(ev.target);
    let value = $elt.val();

    if (value === 'IGNORE')
      $elt.val('DEFAULT');

    if (parseInt(value) == value && $elt.hasClass('disabled')) {
      $elt.removeClass('disabled');
    } else if (parseInt(value) != value && !$elt.hasClass('disabled')) {
      $elt.addClass('disabled');
    }

    $elt.parents('tr').find('[data-row-preview]').addClass('hidden');
    $elt.parents('tr').find('[data-row-preview="'+value+'"]').removeClass('hidden');

    return true;
  }

  headingsChanged(ev) {
    let $elt = $(ev.target);

    let $options = this.$root.find('option[data-alternate-label]');
    for (let i = 0; i < $options.length; i++) {
      let $option = $($options[i]);
      let alternateLabel = $option.data('alternate-label');
      let value = $option.text();
      $option.data('alternate-label', value).attr('data-alternate-label', value);
      $option.text(alternateLabel);
    }

    return true;
  }

}

export default CsvMapModal;



// WEBPACK FOOTER //
// ./resources/assets/js/modals/CsvMapModal.js